<div class="title">
    <span> {{data?.standReportName}} </span>
    <i class="fal fa-times-circle" mat-button cdkFocusInitial [mat-dialog-close]="false"></i>
</div>
<div class="help-content thin-scroll">
    <pre>
    {{data?.longDescription}}    
    </pre>
    <table>
        <tr>
            <th class="column-name">
                {{ 'dashboard:Column Name' | i18next }}
            </th>
            <th>
                {{ 'dashboard:Description' | i18next }}
            </th>
        </tr>
        <tr *ngFor="let colomn of getColumns();index as i" [class.odd]="i % 2">
            <td>{{colomn.shortDescription}}</td>
            <td>{{colomn.longDescription}}</td>            
        </tr>
    </table>
</div>
